if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            //activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
      //  window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* ===== Ascendia: colour-grouped gallery (v4) ================================
 * Pick a colour, see EVERY photo of that colour. A photo that names two
 * colours (a campaign shot with two models) shows under both. Photos whose alt
 * text names no colour always stay visible.
 *
 * v4, 28 Aug 2026 - now works on translated storefronts (/ar) as well as English.
 *   Photo alt text is written in English and Shopify never translates it, but
 *   the colour option NAME and its VALUES are translated. So on /ar the old
 *   code failed twice over: norm() strips every Arabic letter, so the "does the
 *   legend start with color?" test never matched, and the swatch values became
 *   empty strings that matched no photo.
 *   Now: the colour fieldset is found by the .color-swatch class (not
 *   translated), and the ENGLISH match runs FIRST, exactly as before. Only if
 *   that tags fewer than 2 photos - i.e. we are on a translated storefront - do
 *   we fetch the same product in the primary language, join on variant id to
 *   learn the English word for each colour, and re-run the SAME matcher.
 *   English behaviour is therefore byte-identical to v3, and if any part of the
 *   lookup is missing we leave the gallery exactly as we found it.
 *
 * Fails safe, three times over:
 *   - if fewer than 2 photos carry a colour word, the gallery is left alone;
 *   - if the language bridge cannot map EVERY colour, nothing is changed;
 *   - if a colour would end up with an EMPTY gallery, every photo comes back.
 *
 * Two things this has to work around:
 *   1. "Light Green" contains the word "green", so a Light Green photo must not
 *      be counted as Green.
 *   2. The theme's own stylesheet carries
 *        .product__media-item.product__media-item--variant { display: none }
 *      Shopify puts that class on any photo pinned to one variant, so simply
 *      clearing our inline style hands the win straight back to that rule and
 *      the slide stays invisible. We therefore toggle our own class, and we
 *      re-check what the browser ACTUALLY renders before trusting the result.
 * ========================================================================== */
(function () {
  'use strict';

  var STYLE_ID = 'asc-colour-gallery-css';
  if (!document.getElementById(STYLE_ID)) {
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent =
      '.product__media-item.asc-show{display:block !important}' +
      '.product__media-item.asc-hide{display:none !important}';
    (document.head || document.documentElement).appendChild(st);
  }

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  // Find the colour fieldset. First by .color-swatch, a class colour-option.liquid
  // hardcodes, so it survives translation. Second by the English legend, for
  // dropdown pickers that render no swatches.
  // NOTE: .color-swatch is only emitted for an option whose name appears in the
  // theme setting "Swatch option name". That setting must list EVERY localised
  // colour name - today it is "Color" plus the Arabic word. If a language is added, add its
  // colour word there too or this falls back to the English-legend pass.
  function colourGroup(scope) {
    var groups = scope.querySelectorAll('variant-radios fieldset, .product-form__input');
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].querySelector('.color-swatch')) return groups[i];
    }
    for (var j = 0; j < groups.length; j++) {
      var lab = groups[j].querySelector('legend, .form__label, label');
      var n = norm(lab ? lab.textContent : '');
      if (n.indexOf('color') === 0 || n.indexOf('colour') === 0) return groups[j];
    }
    return null;
  }

  function values(group) {
    var out = [];
    var r = group.querySelectorAll('input[type="radio"]');
    if (r.length) {
      for (var i = 0; i < r.length; i++) out.push(r[i].value);
      return out;
    }
    var s = group.querySelector('select');
    if (s) for (var j = 0; j < s.options.length; j++) out.push(s.options[j].value);
    return out;
  }

  function selected(group) {
    var c = group.querySelector('input[type="radio"]:checked');
    if (c) return c.value;
    var s = group.querySelector('select');
    return s ? s.value : null;
  }

  // The variant list the picker already prints, in the CURRENT language.
  function localisedVariants() {
    var el = document.querySelector(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    );
    if (!el) return null;
    try {
      var v = JSON.parse(el.textContent);
      return Array.isArray(v) ? v : null;
    } catch (e) {
      return null;
    }
  }

  // Photo alt text is authored in English and is never translated, but the
  // option values are. On a translated storefront, fetch the SAME product in the
  // primary language and join on variant id to learn the English word for each
  // colour. This reads no translated string and cannot invent a token - if
  // anything is missing we hand back null and the gallery is left alone.
  function englishColourMap(colours, done) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root === '/') return done(null); // already the primary language

    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    var locals = localisedVariants();
    if (!m || !locals || !locals.length || typeof window.fetch !== 'function') return done(null);

    // Which position in options[] is the colour?
    var pos = -1;
    for (var i = 0; i < locals.length && pos === -1; i++) {
      var o = locals[i] && locals[i].options;
      if (!o) continue;
      for (var j = 0; j < o.length; j++) {
        if (colours.indexOf(o[j]) !== -1) { pos = j; break; }
      }
    }
    if (pos === -1) return done(null);

    window
      .fetch('/products/' + m[1] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (en) {
        if (!en || !en.variants || !en.variants.length) return done(null);
        var byId = {};
        en.variants.forEach(function (v) { byId[v.id] = v.options; });

        var map = {};
        locals.forEach(function (v) {
          var e = byId[v.id];
          if (e && v.options && e[pos]) map[v.options[pos]] = e[pos];
        });

        // Every colour must be translated, or we do nothing. A half map would
        // silently mis-tag the colours it failed to learn.
        for (var k = 0; k < colours.length; k++) {
          if (!map[colours[k]]) return done(null);
        }
        done(map);
      })
      .catch(function () { done(null); });
  }

  function setup(gallery) {
    if (gallery.dataset.ascColour === 'v4' || gallery.dataset.ascColour === 'pending') return;

    var root = document.querySelector('product-info') || document;
    var group = colourGroup(root);
    if (!group) return;

    var colours = values(group).filter(Boolean);
    if (colours.length < 2) return;

    var slides = [].slice.call(gallery.querySelectorAll('.product__media-item[data-media-id]'));
    if (!slides.length) return;

    // Tag every photo with the colours named in its alt text.
    // longest first so "Light Green" is tested before "Green"
    function tagWith(list) {
      var ordered = list.slice().sort(function (a, b) {
        return norm(b).length - norm(a).length;
      });

      function match(alt) {
        var hay = ' ' + norm(alt) + ' ';
        var found = [];
        for (var i = 0; i < ordered.length; i++) {
          var c = norm(ordered[i]);
          if (c && hay.indexOf(' ' + c + ' ') !== -1) found.push(c);
        }
        // Drop a colour that is only a fragment of a longer one that also matched:
        // a "Light Green" photo is not a "Green" photo.
        return found.filter(function (c) {
          return !found.some(function (other) {
            return other !== c && (' ' + other + ' ').indexOf(' ' + c + ' ') !== -1;
          });
        });
      }

      var map = {};
      var tagged = 0;
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        var c = match(img ? img.getAttribute('alt') : '');
        map[s.dataset.mediaId] = c;
        if (c.length) tagged++;
      });
      return { map: map, tagged: tagged };
    }

    // English storefront: the swatch values ARE the words in the alt text, so
    // this succeeds and the behaviour is exactly what it has always been.
    var first = tagWith(colours);
    if (first.tagged >= 2) {
      finish(first.map, null);
      return;
    }

    // Translated storefront: the values no longer match the English alt text.
    // Learn the English word for each colour, then run the SAME matcher.
    gallery.dataset.ascColour = 'pending';
    englishColourMap(colours, function (en) {
      gallery.removeAttribute('data-asc-colour');
      if (!en) return;
      var eng = colours.map(function (c) { return en[c]; }).filter(Boolean);
      if (eng.length < 2) return;
      var second = tagWith(eng);
      if (second.tagged < 2) return;
      finish(second.map, en);
    });

    // translate = null on the primary language, or localised -> English map.
    function finish(map, translate) {
      var thumbs = [].slice.call(gallery.querySelectorAll('.thumbnail-list__item[data-target]'));

      function show(el, on) {
        if (el.classList.contains('product__media-item')) {
          el.classList.toggle('asc-show', !!on);
          el.classList.toggle('asc-hide', !on);
          el.style.removeProperty('display');
        } else {
          // explicit 'list-item', not '': Dawn's .thumbnail-list_item--variant:not(:first-child)
          // rule would otherwise hide the selected colour's own front-photo thumbnail
          el.style.display = on ? 'list-item' : 'none';
        }
        if (on) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', 'true');
      }

      function showEverything() {
        slides.forEach(function (s) { show(s, true); });
        thumbs.forEach(function (t) { show(t, true); });
      }

      function apply(colour) {
        if (!colour) return;
        var want = norm(translate ? (translate[colour] || colour) : colour);
        var visible = [];

        slides.forEach(function (s) {
          var c = map[s.dataset.mediaId] || [];
          var on = !c.length || c.indexOf(want) !== -1;
          if (on) visible.push(s);
          show(s, on);
        });

        // Trust the browser, not our own bookkeeping. A slide we asked to show
        // can still be hidden by the theme's stylesheet.
        visible = visible.filter(function (s) {
          return window.getComputedStyle(s).display !== 'none';
        });

        // Never leave a customer looking at a blank white box.
        if (!visible.length) {
          showEverything();
          return;
        }

        thumbs.forEach(function (t) {
          var c = map[t.dataset.target] || [];
          show(t, !c.length || c.indexOf(want) !== -1);
        });

        var active = gallery.querySelector('.product__media-item.is-active');
        if (!active || window.getComputedStyle(active).display === 'none') {
          var firstVisible = visible[0];
          if (typeof gallery.setActiveMedia === 'function') {
            try { gallery.setActiveMedia(firstVisible.dataset.mediaId, false); return; } catch (e) {}
          }
          slides.forEach(function (s) { s.classList.remove('is-active'); });
          firstVisible.classList.add('is-active');
        }
      }

      gallery.dataset.ascColour = 'v4';
      apply(selected(group));

      group.addEventListener('change', function () {
        setTimeout(function () { apply(selected(group)); }, 0);
      });

      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
          setTimeout(function () { apply(selected(group)); }, 0);
        });
      }
    }
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-run after the theme swaps section HTML on variant change.
  setTimeout(boot, 600);
  setTimeout(boot, 1800);
})();
